module.exports = __webpack_public_path__ + "img/1.5 px_medium_grey.86b1cfed.svg";